// @flow

import type { DriverInspection, ExecutionBudgetGroupedList } from './../types';

import {
  fetchRequest,
  initialFetchListParams,
  downloadRequestWithToken
} from './index';
import type { FetchListParams, ListResponse } from './index';
import { convertFromKopToRub, convertFromRubToKop } from './../../lib/helpers';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';

export const convertDataFromServer = (driverInspection: DriverInspection) => ({
  ...driverInspection,
  paymentAmount: convertFromKopToRub(driverInspection.paymentAmount)
});

export const convertDataToServer = (driverInspection: DriverInspection) => ({
  ...driverInspection,
  paymentAmount: convertFromRubToKop(driverInspection.paymentAmount)
});

export const addDriverInspection = async (
  driverInspection: DriverInspection
): Promise<DriverInspection> => {
  const added = await fetchRequest.post(
    '/driverInspection',
    convertDataToServer(driverInspection)
  );
  if (added) return convertDataFromServer(driverInspection);
  throw new Error('Не удалось создать осмотр водителей');
};

export const updateDriverInspection = async (
  driverInspection: DriverInspection
): Promise<DriverInspection> => {
  const updated = await fetchRequest.put(
    '/driverInspection',
    convertDataToServer(driverInspection)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить осмотр водителей');
};
export const deleteDriverInspection = async (
  id: number
): Promise<DriverInspection> => {
  const deleted = await fetchRequest.delete(`/driverInspection/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить осмотр водителей');
};

export const fetchDriverInspection = async (
  id: number,
  params: any = {}
): Promise<DriverInspection> => {
  const driverInspection = await fetchRequest.get(
    `/driverInspection/${id}`,
    params
  );
  if (driverInspection) return convertDataFromServer(driverInspection);
  throw new Error('Не удалось получить список осмотра водителей');
};

export const fetchVehicleDriverInspections = async (
  vehicleId: number,
  params: FetchListParams<any> = initialFetchListParams
): Promise<ListResponse<DriverInspection>> => {
  const driverInspections = await fetchRequest.get(
    `/driverInspection/vehicle/${vehicleId}`,
    {
      ...initialFetchListParams,
      ...params
    }
  );
  if (driverInspections) {
    return {
      ...driverInspections,
      data: driverInspections.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список осмотра водителей');
};

export const fetchDriverInspections = async (
  params: FetchListParams<DriverInspection> = initialFetchListParams
): Promise<ListResponse<DriverInspection>> => {
  const driverInspections = await fetchRequest.get('/driverInspection', {
    ...initialFetchListParams,
    ...params
  });
  if (driverInspections) {
    return {
      ...driverInspections,
      data: driverInspections.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список осмотра водителей');
};

export const groupedList = async (
  params: any = {}
): Promise<ListResponse<ExecutionBudgetGroupedList>> => {
  const groupedList = await fetchRequest.get(
    `/driverInspection/groupedList`,
    params
  );
  if (groupedList)
    return {
      ...groupedList,
      data: groupedList.data.map(convertDataFromServerGroupedList)
    };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const printReport = async (
  params: any,
  fileName?: string
): Promise<boolean> => {
  const isPrinted = await downloadRequestWithToken(
    '/driverInspection/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export default {
  groupedList,
  addDriverInspection,
  updateDriverInspection,
  deleteDriverInspection,
  fetchDriverInspection,
  fetchVehicleDriverInspections,
  fetchDriverInspections,
  printReport
};
